var AT_Slider ={
  
  	owlSlider : function(){
      
      	jQuery(".list-latest-product").length && jQuery('.list-latest-product').owlCarousel({
          	nav			: true
          	,dots 		: false
      		,items		: 4
			,responsive : {
                0:{
                	items: 1
                }
              	,480:{
                	items: 2
                }
            	,768:{
              		items: 3
            	}
            	,1024:{
              		items: 4
            	}
          	}
          	,navText	: ['<i class="fa fa-chevron-circle-left fa-3" title="previous"></i>', '<i class="fa fa-chevron-circle-right fa-3" title="Next"></i>']
        });
      
      	jQuery(".latest-blog-slider").length && jQuery('.latest-blog-slider').owlCarousel({
          	autoplay	: true
          	,loop		: true
          	,dots 		: false
      		,items		: 1
        });
      
      	jQuery(".banner-slider-content").length && jQuery('.banner-slider-content').owlCarousel({
          	nav			: true
          	,dots 		: false
      		,items		: 1
          	,navText	: ['<i class="fa fa-chevron-circle-left fa-3" title="previous"></i>', '<i class="fa fa-chevron-circle-right fa-3" title="Next"></i>']
          	,animateOut: 'fadeOut'
        });
      
      	jQuery(".related-items").length && jQuery('.related-items').owlCarousel({
          	nav			: true
          	,dots 		: false
      		,items		: 4
			,responsive : {
                0:{
                	items: 1
                }
            	,480:{
              		items: 2
            	}
            	,768:{
              		items: 3
            	}
            	,1024:{
              		items: 4
            	}
          	}
          	,navText	: ['<i class="fa fa-chevron-circle-left fa-3" title="previous"></i>', '<i class="fa fa-chevron-circle-right fa-3" title="Next"></i>']
        });

        jQuery("#gallery-image").length && jQuery('#gallery-image').owlCarousel({
            nav			: false
          	,dots 		: true
          	,mouseDrag	: true
          	,margin: 0
			,responsive : {
                0:{
                	items: 3
                }
              	,480:{
                	items: 5
                }
                ,768:{
                      items: 3
                }
            	,1199:{
              		items: 6
            	}
          	}
			
        });
    	
	}
  
  	,init : function(){
      this.owlSlider();
    }
  
}

/* Ajax Pagination */

var AT_AjaxPagination = {
  pInfScrExecute: function(){
    pInfScrNode = $('.load_more').last();	
    pInfScrURL = $('.load_more a').last().attr("href");
    if(pInfScrNode.length) {
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          jQuery('.load_more').addClass('invisible');
          jQuery('.loading').fadeIn();
        },
        success: function(data) {
          var filteredData = $(data).find(".product-grid-item");
          jQuery(".best-product ul").append(filteredData);
          SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
          jQuery('.loading').fadeOut();

          if(jQuery(data).find(".load_more a").length){
            jQuery('.load_more a').last().attr("href", jQuery(data).find(".load_more a").last().attr("href"));
            jQuery('.load_more').removeClass('invisible');
          }
          else{
            jQuery('.load_more').remove();
          }
        },
        dataType: "html"
      });
    }
  }
  ,attachClickEvent: function(){
    jQuery('.load_more a').click(function(event){
      AT_AjaxPagination.pInfScrExecute();
      event.stopPropagation();
      return false;
    });
  }
  ,init: function(){
    this.attachClickEvent();
  }
}


/* Check IE */
var bcMsieVersion = {

  MsieVersion: function() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer, return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    else                 // If another browser, return 0
      {
      return 0;
    }
  }

  ,init : function(){
    this.MsieVersion();
  }
}

jQuery(document).ready(function($) {
	
	AT_Slider.init();
  	AT_AjaxPagination.init();
      
});